(() => {
  const mounted = new WeakMap();
  const init = (scope) => scope.querySelectorAll('[data-paper-process]').forEach(root => {
    if (mounted.has(root) || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) root.classList.add('is-playing');
      observer.disconnect();
    }, { threshold: 0.15 });
    observer.observe(root);
    mounted.set(root, observer);
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-paper-process]').forEach(root => { mounted.get(root)?.disconnect(); mounted.delete(root); }));
})();
